"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CalendarDatasController", {
    enumerable: true,
    get: function() {
        return CalendarDatasController;
    }
});
const _common = require("@nestjs/common");
const _express = require("express");
const _globalguard = require("~/guards/global/global.guard");
const _dataapilimiterguard = require("~/guards/data-api-limiter.guard");
const _calendardatasservice = require("~/services/calendar-datas.service");
const _helpers = require("~/helpers");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let CalendarDatasController = class CalendarDatasController {
    async dataList(context, req, viewId, fromDate, toDate, prevDate, nextDate) {
        return await this.calendarDatasService.getCalendarDataList(context, {
            viewId: viewId,
            query: req.query,
            from_date: fromDate,
            to_date: toDate,
            next_date: nextDate,
            prev_date: prevDate
        });
    }
    async calendarDataCount(context, req, res, baseName, tableName, viewName, fromDate, toDate, prevDate, nextDate) {
        const startTime = process.hrtime();
        const data = await this.calendarDatasService.getCalendarRecordCount(context, {
            query: req.query,
            viewId: viewName,
            from_date: fromDate,
            to_date: toDate,
            next_date: nextDate,
            prev_date: prevDate
        });
        const elapsedSeconds = (0, _helpers.parseHrtimeToMilliSeconds)(process.hrtime(startTime));
        res.setHeader('xc-db-response', elapsedSeconds);
        res.json(data);
    }
    async countByDate(context, req, sharedViewUuid, fromDate, toDate, prevDate, nextDate) {
        var _req_headers;
        return await this.calendarDatasService.getPublicCalendarRecordCount(context, {
            query: req.query,
            password: (_req_headers = req.headers) == null ? void 0 : _req_headers['xc-password'],
            sharedViewUuid,
            from_date: fromDate,
            to_date: toDate,
            next_date: nextDate,
            prev_date: prevDate
        });
    }
    async getPublicCalendarDataList(context, req, sharedViewUuid, fromDate, toDate, prevDate, nextDate) {
        var _req_headers;
        return await this.calendarDatasService.getPublicCalendarDataList(context, {
            query: req.query,
            password: (_req_headers = req.headers) == null ? void 0 : _req_headers['xc-password'],
            sharedViewUuid,
            from_date: fromDate,
            to_date: toDate,
            next_date: nextDate,
            prev_date: prevDate
        });
    }
    constructor(calendarDatasService){
        this.calendarDatasService = calendarDatasService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/calendar-data/:orgs/:baseName/:tableName/views/:viewName'
    ]),
    (0, _extractidsmiddleware.Acl)('dataList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('viewName')),
    _ts_param(3, (0, _common.Query)('from_date')),
    _ts_param(4, (0, _common.Query)('to_date')),
    _ts_param(5, (0, _common.Query)('prev_date')),
    _ts_param(6, (0, _common.Query)('next_date')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], CalendarDatasController.prototype, "dataList", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/calendar-data/:orgs/:baseName/:tableName/views/:viewName/countByDate/'
    ]),
    (0, _extractidsmiddleware.Acl)('dataList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Res)()),
    _ts_param(3, (0, _common.Param)('baseName')),
    _ts_param(4, (0, _common.Param)('tableName')),
    _ts_param(5, (0, _common.Param)('viewName')),
    _ts_param(6, (0, _common.Query)('from_date')),
    _ts_param(7, (0, _common.Query)('to_date')),
    _ts_param(8, (0, _common.Query)('prev_date')),
    _ts_param(9, (0, _common.Query)('next_date')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        typeof _express.Response === "undefined" ? Object : _express.Response,
        String,
        String,
        String,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], CalendarDatasController.prototype, "calendarDataCount", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/public/calendar-view/:sharedViewUuid/countByDate',
        '/api/v2/public/calendar-view/:sharedViewUuid/countByDate'
    ]),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('sharedViewUuid')),
    _ts_param(3, (0, _common.Query)('from_date')),
    _ts_param(4, (0, _common.Query)('to_date')),
    _ts_param(5, (0, _common.Query)('prev_date')),
    _ts_param(6, (0, _common.Query)('next_date')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], CalendarDatasController.prototype, "countByDate", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/public/calendar-view/:sharedViewUuid',
        '/api/v2/public/calendar-view/:sharedViewUuid'
    ]),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('sharedViewUuid')),
    _ts_param(3, (0, _common.Query)('from_date')),
    _ts_param(4, (0, _common.Query)('to_date')),
    _ts_param(5, (0, _common.Query)('prev_date')),
    _ts_param(6, (0, _common.Query)('next_date')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        String,
        String,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], CalendarDatasController.prototype, "getPublicCalendarDataList", null);
CalendarDatasController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_dataapilimiterguard.DataApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _calendardatasservice.CalendarDatasService === "undefined" ? Object : _calendardatasservice.CalendarDatasService
    ])
], CalendarDatasController);
